import { render, staticRenderFns } from "./ElectricFence.vue?vue&type=template&id=0b5c4024&scoped=true&"
import script from "./ElectricFence.vue?vue&type=script&lang=js&"
export * from "./ElectricFence.vue?vue&type=script&lang=js&"
import style0 from "./ElectricFence.vue?vue&type=style&index=0&id=0b5c4024&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c4024",
  null
  
)

export default component.exports